import { render, staticRenderFns } from "./WelcomePanelBanner.vue?vue&type=template&id=33dad2f2"
import script from "./WelcomePanelBanner.vue?vue&type=script&lang=js"
export * from "./WelcomePanelBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports